import { Container, Row, Col } from "react-bootstrap";
import InfoCard from "../../components/Generic/InfoCard";
import "../../styles/Training.css";

const TraininPrograms = () => {
  return (
    <section className="py-5 text-white">
      <Container>
        <Row className="g-4 align-items-stretch">
          <Col md={4}>
            <div className="section-left-border ">
              <h2 className="wise-secondary-gradient">FIVE CAREER PROGRAMS</h2>
              <p className="text-secondary mt-3">
                WiSE Programs are designed across five career cohorts to provide relevant, stage-specific support aligned with real-world growth in the semiconductor ecosystem.
              </p>
            </div>
          </Col>

          <Col md={4}>
            <InfoCard
            variant="program"
              number="01"
              title="Campus to Corporate"
              subtitle="Crawl"
              image="/assets/training/crawl.svg"
              description="Designed for students and early graduates to build technical foundations, soft skills, and industry readiness for a confident corporate transition."
            />
          </Col>

          <Col md={4}>
            <InfoCard
            variant="program"
              number="02"
              title="Career Entrench"
              subtitle="Climb & Consolidate"
              image="/assets/training/climb.svg"
              description="Supports early-to-mid career professionals in strengthening expertise, leadership presence, and professional networks for sustained career growth."
            />
          </Col>

          <Col md={4}>
            <InfoCard
            variant="program"
              number="03"
              title="Career Advance"
              subtitle="Cultivate & Craft"
              image="/assets/training/cultivate.svg"
              description="Empowers professionals preparing for advanced or leadership roles with strategic planning, team development, and greater industry visibility."
            />
          </Col>

          <Col md={4}>
            <InfoCard
            variant="program"
              number="04"
              title="Career Coach"
              subtitle="Command & Contribute"
              description="Enables senior leaders to drive executive impact, champion DEI initiatives, and mentor others while influencing the broader ecosystem."
              image="/assets/training/command.svg"
            />
          </Col>

          <Col md={4}>
            <InfoCard
            variant="program"
              number="05"
              title="Reignite"
              subtitle="Comeback"
              image="/assets/training/comeback.svg"
              description="Supports women returning from career breaks with skill refresh, mentorship, and renewed confidence to re-enter the semiconductor industry."
      
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TraininPrograms;
